module.exports = __webpack_public_path__ + "static/media/ro.5564f77d.jpg";